const CACHE_TTL = 4 * 60 * 60 * 1000; // 4 hours

let cache = {};

export async function fetchExchangeRate(from, to) {
  const key = `${from}_${to}`;
  const cached = cache[key];
  if (cached && Date.now() - cached.fetchedAt < CACHE_TTL) {
    return cached;
  }

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);

  try {
    const res = await fetch(
      `https://api.frankfurter.app/latest?from=${from}&to=${to}`,
      { signal: controller.signal }
    );
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    const rate = data.rates[to];
    if (!rate) throw new Error(`No rate for ${to}`);
    const result = { rate, fetchedAt: Date.now() };
    cache[key] = result;
    return result;
  } finally {
    clearTimeout(timeout);
  }
}
